import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { BookOpen, ArrowRight, Check } from "lucide-react";
import { toast } from "sonner";

export default function Devotionals() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/devotionals").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e))).finally(() => setLoading(false));
  }, []);

  const readCount = items.filter((d) => d.read).length;

  return (
    <div className="space-y-8">
      <div className="fade-up">
        <p className="text-xs tracking-[0.2em] uppercase text-[#8C6A54] font-semibold">Daily Bread</p>
        <h1 className="font-heading text-5xl text-[#2A2621] mt-2">Devotionals</h1>
        <p className="text-[#615A50] mt-2">Draw near to God through His Word. Read, reflect, and be renewed.</p>
        {!isAdmin && items.length > 0 && (
          <p className="text-sm text-[#3D5844] mt-3 font-medium" data-testid="devotional-progress">You've read {readCount} of {items.length}</p>
        )}
      </div>

      {loading ? <p className="text-[#615A50]">Gathering devotionals…</p> : (
        <div className="grid md:grid-cols-2 gap-6">
          {items.map((d, i) => (
            <Link key={d.id} to={`/devotionals/${d.id}`} data-testid={`devotional-${d.id}`}
              className="rounded-2xl border border-[#D5CEBF] bg-[#F3EFE4] p-7 hover:-translate-y-1 transition-transform duration-300 fade-up" style={{ animationDelay: `${i * 0.05}s` }}>
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 text-[#6B4A38] text-sm"><BookOpen className="w-4 h-4" /> {d.scripture_ref || "Scripture"}</div>
                {d.read && <span data-testid={`devotional-read-badge-${d.id}`} className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full bg-[#3D5844]/10 text-[#3D5844] font-medium"><Check className="w-3 h-3" /> Read</span>}
              </div>
              <h3 className="font-heading text-3xl text-[#2A2621] mt-2">{d.title}</h3>
              <p className="text-sm text-[#615A50] mt-2 leading-relaxed line-clamp-3">{d.body}</p>
              <div className="flex items-center justify-between mt-5 text-sm">
                <span className="text-[#615A50]">{d.date ? new Date(d.date).toLocaleDateString(undefined, { month: "long", day: "numeric" }) : ""}</span>
                <span className="inline-flex items-center gap-1 text-[#C46B4E] font-medium">Read <ArrowRight className="w-4 h-4" /></span>
              </div>
            </Link>
          ))}
          {items.length === 0 && <p className="text-[#615A50]">No devotionals posted yet — check back soon.</p>}
        </div>
      )}
    </div>
  );
}
